module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idgenobjectstyleoverride",
    attrs: {
      "id": "_idContainer1347"
    }
  }, [_c('p', {
    staticClass: "content-chapter",
    attrs: {
      "id": "calibre_toc_7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/5Ingredient_split_006#_idTextAnchor022"
    }
  }, [_vm._v("Thrive Market"), _c('span', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "body_body1",
    attrs: {
      "id": "calibre_pb_48"
    }
  }, [_vm._v("If you like saving money, want to get most of the ingredients used in this cookbook, and don’t feel like going to the grocery store, you should check out Thrive Market. They have been a trusted partner on the "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("FlavCity")]), _vm._v(" YouTube channel for over four years. They have healthy and organic groceries with prices that are cheaper than the grocery store. I created a special landing page that has most all the ingredients used in this book along with an exclusive offer for "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("FlavCity")]), _vm._v(" fans; go to thrivemarket.com/bobbyapproved. The membership fee pays for itself, and their 100% grass-fed ghee is one of my favorite th"), _c('span', [_vm._v("ings")]), _c('span'), _c('span', [_vm._v("ever!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32029593","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/5Ingredient_split_028.vue
// module id = 141
// module chunks = 0